import { JSONObject } from '../../../../types/types';
import { resolveStringExpression } from '../../../../utils/json/resolveStringExpression';
import {
  FormVisibilityNode,
  getInitialFormItemVisibility,
} from './getInitialFormItemVisibility';

export const resolveFormItemVisibility = async (
  node: FormVisibilityNode,
  resolveData: JSONObject
): Promise<boolean> => {
  if (node.allowVisible === false) {
    return false;
  }

  let isVisible = getInitialFormItemVisibility({ visible: node.visible });
  if (typeof node.visible === 'string') {
    isVisible = Boolean(
      await resolveStringExpression(node.visible, resolveData)
    );
  }

  if (!isVisible) {
    return false;
  }

  if (!Array.isArray(node.items)) {
    return true;
  }

  const childVisibility = await Promise.all(
    node.items.map((item) => resolveFormItemVisibility(item, resolveData))
  );
  return childVisibility.some(Boolean);
};
